import React from "react";
import { chevronLeftIcon } from "../../img/font_awesome/font_awesome";
import "../../landnotification.css";

export default function BackButton({ onClick, ariaLabel = "Back" }) {
  return (
    <button
      type="button"
      className="mobile-back-button"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {chevronLeftIcon}
    </button>
  );
}
